import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sms-coupon",
  "use": "icon-sms-coupon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sms-coupon\"><defs><style type=\"text/css\"></style></defs><path d=\"M695.466667 535.466667h-153.6v-78.933334h147.2v-59.733333h-130.133334l108.8-108.8-38.4-38.4-117.333333 117.333333-117.333333-117.333333-38.4 38.4 108.8 108.8h-130.133334v59.733333h147.2v78.933334h-153.6V597.333333h153.6v177.066667h59.733334V597.333333h153.6z\" fill=\"\" p-id=\"8265\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sms-coupon.svg
// module id = 0Kk2
// module chunks = 19